import { ReactNode } from 'react';
import cn from 'classnames';
import IconEmailAlerts from '@dealroadshow/uikit/core/components/Icon/IconEmailAlerts';
import IconEmailChecked from '@dealroadshow/uikit/core/components/Icon/IconEmailChecked';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import Button, { ButtonVariantType } from '@dealroadshow/uikit/core/components/Button';
import Spinner from '@dealroadshow/uikit/core/components/Loader/Spinner';

import styles from './SubscribeButton.scss';

interface IProps {
  tooltip: ReactNode,
  onClick: () => void,
  isDisabled: boolean,
  isFetching?: boolean,
  isSubscribed?: boolean,
  dataTest?: string,
  className?: string,
}

const SubscribeButton = ({
  tooltip,
  onClick,
  isDisabled,
  isSubscribed,
  isFetching,
  dataTest,
  className,
}: IProps) => (
  <Button
    dataTest={ dataTest || 'subscribeButton' }
    variant={ ButtonVariantType.text }
    onClick={ onClick }
    className={ cn(styles.subscribeButton, { [styles.isSubscribed]: isSubscribed }, className) }
    disabled={ isDisabled }
  >
    { isFetching
      ? <Spinner size="xsmall" />
      : (
        <Tooltip
          content={ tooltip }
          containerClassName={ styles.subscribeButton }
        >
          { isSubscribed ? <IconEmailChecked /> : <IconEmailAlerts /> }
        </Tooltip>
    ) }
  </Button>
);

export default SubscribeButton;
